<div class="pickerDiv">
    <app-channel-picker (channelSelected)="filterByChannel($event)"
        [currentChannel]="currentChannelFilter"></app-channel-picker>
</div>
<app-form-page [config]="config"></app-form-page>
